import { render, staticRenderFns } from "./HomeTeacher.vue?vue&type=template&id=8596315c"
import script from "./HomeTeacher.vue?vue&type=script&lang=js"
export * from "./HomeTeacher.vue?vue&type=script&lang=js"
import style0 from "./HomeTeacher.vue?vue&type=style&index=0&id=8596315c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports